<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            {{allData.name}}
            <el-button class="exit" size="mini" @click="exit()"><img src="../../../static/images/end-back.png" alt="" srcset=""> &nbsp; 退 出 </el-button>
        </div>
        <div class="main">
            <div class="mainStyle">
                <el-carousel
                    ref="carousel"
                    trigger="click"
                    :initial-index="initIndex"
                    :autoplay="false"
                    :loop="false"
                    arrow="never" 
                    @change="onChange"
                    indicator-position="none" 
                    class="carouselItem"
                >
                    <div v-for="(item,index) in topicList" :key="index">
                        <el-carousel-item v-for="(son,i) in item.questionList" :key="index+i">
                            <err-topic :ref="'topicRef'+son.bId" :questionText="son" :serial="son.serial" :answer="testCompleted[son.serial-1]"></err-topic>
                        </el-carousel-item>
                    </div>
                </el-carousel>
            </div>
        </div>
        <div class="footer">
            <el-button class="upSub" v-show="buttonNum>1" @click="lastQuestion()">上一题</el-button>
            <el-button class="sub" :style="{width:(buttonNum>1? '20%':'30%')}" @click="nextQuestion()">{{`${buttonText} ${buttonNum}/${buttonTotal}`}}<span>题</span> </el-button>
        </div>
    </div>
</template>
<script>
import errTopic from '../../components/examRecords/errTopic'
import utils from '../../lib/util'
    export default {
        name:"problem",
        data() {
            return {
                tableing:false,
                allData:{},
                topicList:[],
                progress:1,
                buttonTotal:1,
                buttonNum:1,
                initIndex:0,
                endDateVal:'',
                startDateVal:'',
                upTopic:true,
                topicType:['10','11','12','20','30','50','60','61'],
                keYimarking:['10','11','12','50'],
                timer:'',
                examMinTime:'00:00:00',
                testCompleted:[],
            }
        },
        components:{
            errTopic
        },
        created(){},
        watch: {},
        computed:{
            buttonText: function () {
                let t = ''
                this.buttonTotal == this.buttonNum? t ='返 回':t ='下一题'
                return t
            }
        },
        mounted(){
            this.$nextTick(function(){
                this.getData()
                this.getPaperCom()
            })
            this.endDateVal = utils.fmtDate(new Date(),'yyyy-MM-dd hh:mm:ss')
        },
        methods:{
            getData(){
                let that = this
                that.tableing = true
                that.$axios.post('/paper/info',{
                    isFull:'1',
                    paperId:that.$route.query.paperId,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    that.tableing = false;
                    let v = res.data;
                    if (v.code == 0) {
                        that.allData = v.data
                        // reviewType 1=前台自动阅卷 2=后台阅卷
                        let b = 1
                        that.topicList = v.data.groupList.map((item)=>{
                            item.questionList = item.questionList.map((results)=>{
                                results['serial'] = b;
                                that.buttonTotal = b;
                                b++;
                                return results
                            })
                            return item
                        })
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            getPaperCom(){
                let that = this
                that.tableing = true
                that.$axios.post('/paper/acg/userPaperInfo',{
                    userPaperId:that.$route.query.id,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    that.tableing = false;
                    let v = res.data;
                    if (v.code == 0) {
                        that.allData = v.data
                        // reviewType 1=前台自动阅卷 2=后台阅卷
                        that.testCompleted = v.data.detailsList
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            nextQuestion(){
                let that = this
                try {
                    that.topicList.forEach((element,index) => {
                        element.questionList.forEach((ele,i) => {
                            let first = JSON.stringify(that.$refs.carousel.activeIndex)
                            let x = JSON.parse(first)
                            if(ele.serial == x+1){
                                // 切换下一题，结束上一题音频 60 
                                if(that.topicType.indexOf(ele.questionDto.typeCode)!=-1){eval("that.$refs.topicRef" +(ele.bId))[0].endAudio()}
                                // 如果是最后一题》提交
                                if(that.buttonNum == that.buttonTotal){
                                    this.exit();
                                    throw new Error("breakForEach");
                                }
                                that.$refs.carousel.next()
                                that.buttonNum = that.$refs.carousel.activeIndex+1
                                throw new Error("breakForEach");
                            }
                        });
                    });
                } catch (e) {
                    if (e.message!="breakForEach") throw e;
                }
            },
            lastQuestion(){
                let that = this
                try {
                    that.topicList.forEach((element,index) => {
                        element.questionList.forEach((ele,i) => {
                            let first = JSON.stringify(that.$refs.carousel.activeIndex)
                            let x = JSON.parse(first)
                            if(ele.serial == x+1){
                                // 切换下一题，结束下一题音频 
                                if(that.topicType.indexOf(ele.questionDto.typeCode)!=-1){eval("that.$refs.topicRef" +(ele.bId))[0].endAudio()}
                                // 如果是最后一题提交
                                that.$refs.carousel.prev()
                                that.buttonNum--
                                throw new Error("breakForEach");
                            }
                        });
                    });
                } catch (e) {
                    if (e.message!="breakForEach") throw e;
                }
            },
            exit(){
                this.$router.go(-1) 
            },
            onChange(currentTime,oldIndex){
                // console.log(`当前索引：${currentTime}, 原索引：${oldIndex}`)
            },
            dealExamMin(v){
                return utils.formateSeconds(v)
            },
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
    }
    .examTime{
        height: 20px;
        position: absolute;
        top: -13px;
        right: 35px;
        font-size: 18px;
        color: red;
    }
    .exit{
        background-color: rgb(96,161,251);
        border: none;
        font-size: 13px;
        color: #fff;
        position: absolute;
        top: 30px;
        right: 35px;
        img{
            height: 10px;
        }
    }
    .main{
        position: absolute;
        top: 60px;
        bottom: 100px;
        left: 35px;
        right: 35px;
    }
    .mainStyle{
        height: 100%;
        width: 100%;
        position: relative;
    }
    .carouselItem{
        height: 100%;
        width: 100%;
        .el-carousel__container{
            height: 100% !important;
        }
    }
    .footer{
        position: absolute;
        bottom: 0;
        height: 100px;
        left: 0;
        right: 0;
        width: 100%;
        .sub{
            background: rgb(0, 75, 180);
            color: #FFF;
            font-size: 15px;
        }
        .upSub{
            width: 20%;
            background-color: #1C81FE;
            color: #FFF;
            font-size: 15px;
        }

    }
</style>
<style>
    .carouselItem .el-carousel__container{
        height: 100% !important;
    }
    .exitExam .el-dialog__body{
        padding: 25px 25px 15px;
        text-align: center;
        font-size: 16px;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// src/pages/examRecords/errProblem.vue